// extracted by mini-css-extract-plugin
export default {"spinnerContianer":"Spinner_spinnerContianer__pnKTB","loader":"Spinner_loader__FXNs5","rotate":"Spinner_rotate__Nveyw","prixClipFix":"Spinner_prixClipFix__oPeqA"};